var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Profile",
            "fields": [],
            "messages": [
                {
                    "name": "Set",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "ProfileSet",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "username",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "setting",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "upliveCode",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "signature",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "PushType",
                                    "name": "pushType",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "pushToken",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "location",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "gender",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "language",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "countryCode",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "userRealNameAuthInfo",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "acceptAgreement",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "timeZone",
                                    "id": 14
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/profile/set.pb.js